// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, default-param-last */
import { Record, Map } from "immutable"

export const ModalsState = Record({
  login: null,
  forgotPassword: null,
  signUpConfirm: null,
  creatingPassword: null,
  verifyEmail: null,
  errorModal: null,
  debug: null,
  salesmanOnboarding: null,
  subscription: null,
  outdatedData: null,
})

export default function ModalsReducer(state = new ModalsState(), action) {
  switch (action.type) {
    case "MODALS_SHOW":
      return state.set(action.modalType, Map(action.params))

    case "MODALS_HIDE":
      return state.set(action.modalType, null)

    default:
      return state
  }
}
